import React from "react";

import Widget from "../../components/Widget/index";
import { useSelector } from "react-redux";
import { THEME_TYPE_DARK } from "../../constants/ThemeSetting";
import { ResponsiveContainer } from "recharts";

const IconWithTextCard = (props) => {
  const { icon, title, subTitle } = props;
  const { themeType } = useSelector(({ settings }) => settings);
  let { iconColor } = props;
  if (themeType === THEME_TYPE_DARK) {
    iconColor = "white";
  }

  return (
    <Widget>
      <ResponsiveContainer width="100%" height={95}>
        <div className="gx-media gx-align-items-center gx-flex-nowrap">
          <div className="gx-mr-lg-4 gx-mr-3">
            <i className={`icon icon-${icon} gx-fs-xlxl gx-text-${iconColor} gx-d-flex`}
              style={{ fontSize: 65 }} />
          </div>
          <div className="gx-media-body">
            <h1 className="gx-fs-xxxl gx-font-weight-medium gx-mb-1">{title}</h1>
            <p className="gx-text-grey gx-mb-0">{subTitle}</p>
          </div>
        </div>
      </ResponsiveContainer>
    </Widget>
  );
};
export default IconWithTextCard;
